import React from 'react';

import * as S from './styled';

export const Section = Object.assign(S.Section, {
  Title: S.Title,
  Row: S.Row,
});
